// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"472":"f3cbeeae","651":"c002b663","910":"d3e6a8a8"}[chunkId] + ".chunk.css";
};